
import Component, { mixins } from 'vue-class-component';
import WidgetMixins from '../../../mixins/WidgetMixins';
import DialogMixins from '../../../mixins/DialogMixins';
import { loadWidget } from '@/utils/helpers';
import { Getter, namespace } from 'vuex-class';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, ext ,alpha_num} from 'vee-validate/dist/rules';
import { IReport, IUser } from '@/types/types';
const auth = namespace('auth');
extend('required', {
  ...required,
  message: `Field is required`,
});
extend('ext', {
  ...ext,
  message: `Invalid file type`,
});
extend('alpha_num', {
  ...alpha_num,
  message: `Invalid input provided. Only alphanumeric characters are allowed.`,
});
@Component({
  name: 'Index',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
    EmptyPage: loadWidget('pages/EmptyPage'),
    ProgressBar: loadWidget('widgets/CircularProgressLoader'),
    ValidationProvider,
    ValidationObserver,
  },
  filters: {},
})
export default class Index extends mixins(WidgetMixins, DialogMixins) {
  @Getter('getCreditBalance') creditBalance!: number;
  @auth.Getter('getUserDetails') details!: IUser;

  bug: IReport & { screenshot: string } = {
    title: '',
    content: '',
    screenshot: '',
  };

  previewUrl: ArrayBuffer | null | undefined | string = '';

  photo(file: File): void {
    console.log(file);
    if (file) {
      let reader = new FileReader();
      reader.onload = (ev) => {
        this.previewUrl = ev.target?.result;
      };
      reader.readAsDataURL(file);
      // getting  the form data for the app
    } else {
      this.previewUrl = null;
    }
  }

  reportBug(): void {
    this.$store.dispatch('log/reportBug', {
      ...this.bug,
      screenshot: this.previewUrl,
    });
  }
}
